const getLocalStorage = (): Storage | null => {
  if (typeof globalThis === 'undefined') return null;
  try {
    return globalThis.localStorage ?? null;
  } catch {
    return null;
  }
};

export const localPersistStorage = {
  getItem(key: string): Promise<string | null> {
    const ls = getLocalStorage();
    return Promise.resolve(ls ? ls.getItem(key) : null);
  },
  setItem(key: string, value: string): Promise<void> {
    const ls = getLocalStorage();
    if (ls) ls.setItem(key, value);
    return Promise.resolve();
  },
  removeItem(key: string): Promise<void> {
    const ls = getLocalStorage();
    if (ls) ls.removeItem(key);
    return Promise.resolve();
  },
};
